import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Send, Loader2, CheckCircle, Clock, AlertTriangle } from 'lucide-react';
import { Button } from '../ui/button';

const dateFr = (d) => new Date(d).toLocaleDateString('fr-FR');

const statutEnvoi = (tests) => {
  if (!tests?.date_envoi) return { libelle: 'Non envoyé au candidat', Icone: Clock, ton: 'bg-amber-50 border-amber-200 text-amber-800', bouton: 'Envoyer au candidat' };
  if (tests.modifie_apres_envoi) return { libelle: `Modifié depuis l'envoi du ${dateFr(tests.date_envoi)}`, Icone: AlertTriangle, ton: 'bg-orange-50 border-orange-200 text-orange-800', bouton: 'Renvoyer au candidat' };
  return { libelle: `Envoyé au candidat le ${dateFr(tests.date_envoi)}`, Icone: CheckCircle, ton: 'bg-green-50 border-green-200 text-green-800', bouton: 'Renvoyer' };
};

// Envoi manuel des résultats au candidat (e-mail + attestation + notification)
export const EnvoiTestsCandidat = ({ candidatId, tests, onEnvoye }) => {
  const [envoi, setEnvoi] = useState(false);
  const { libelle, Icone, ton, bouton } = statutEnvoi(tests);

  const envoyer = async () => {
    if (!window.confirm('Envoyer les résultats des tests au candidat (e-mail avec attestation + notification) ?')) return;
    setEnvoi(true);
    try {
      const { data } = await axios.post(`/candidats/${candidatId}/tests/envoyer`);
      toast.success(data.email_envoye ? 'Résultats envoyés au candidat par e-mail' : "Résultats publiés dans l'espace candidat (e-mail non envoyé)");
      onEnvoye?.();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de l'envoi");
    } finally {
      setEnvoi(false);
    }
  };

  return (
    <div className={`flex flex-col sm:flex-row sm:items-center gap-2 p-3 border rounded-lg ${ton}`} data-testid="tests-envoi-statut">
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <Icone className="h-4 w-4 shrink-0" />
        <span className="text-sm font-medium" data-testid="tests-envoi-libelle">{libelle}</span>
      </div>
      <Button size="sm" onClick={envoyer} disabled={envoi} className="bg-purple-600 hover:bg-purple-700 text-white" data-testid="btn-envoyer-tests">
        {envoi ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Send className="h-4 w-4 mr-1" />}
        {bouton}
      </Button>
    </div>
  );
};
